module.exports = __webpack_public_path__ + "img/snapsheet-preview.96d00d88.png";